import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "reactstrap";
import {
  FaClipboardList,
  FaCalendarDay,
  FaShoppingCart,
  FaUser,
  FaBoxes,
  FaTags,
  FaFileInvoice,
  FaStore,
  FaWarehouse,
  FaExclamationTriangle,
  FaCoins,
} from "react-icons/fa";
import {
  openView,
  openViewWithParams,
} from "../../ReduxToolkit/Reducers/viewReducer";
import { useDispatch } from "react-redux";

const reports = [
  {
    title: "Close Reports",
    description: "View all closed registers with detailed transactions.",
    icon: <FaClipboardList size={30} className="text-primary" />,
    link: "reports_close",
  },
  {
    title: "End Day Reports",
    description: "Get a summary of all transactions at the end of the day.",
    icon: <FaCalendarDay size={30} className="text-success" />,
    link: "reports_eod",
  },
  {
    title: "Transaction Reports",
    description: "List all transactions from the past 2 years.",
    icon: <FaShoppingCart size={30} className="text-warning" />,
    link: "reports_transactions",
    params: { backTo: "reports" },
  },
  {
    title: "Sales by User",
    description: "View sales reports filtered by individual users.",
    icon: <FaUser size={30} className="text-info" />,
    link: "reports_sales_user",
    params: { backTo: "reports" },
  },
  {
    title: "Sales by Item",
    description: "Get sales details based on specific items sold.",
    icon: <FaBoxes size={30} className="text-danger" />,
    link: "reports_sales_item",
    params: { backTo: "reports" },
  },
  {
    title: "Sales by Category",
    description: "Track sales based on product categories.",
    icon: <FaTags size={30} className="text-primary" />,
    link: "reports_sales_category",
    params: { backTo: "reports" },
  },
  {
    title: "Sales Tax Reports",
    description: "See tax collected over a period of time.",
    icon: <FaFileInvoice size={30} className="text-secondary" />,
    link: "reports_sales_tax",
    params: { backTo: "reports" },
  },
  {
    title: "Sales by Platform",
    description: "Compare sales from online and in-store transactions.",
    icon: <FaStore size={30} className="text-success" />,
    link: "reports_sales_platform",
    params: { backTo: "reports" },
  },
  {
    title: "Stock Report",
    description: "Get an overview of current stock levels for all products.",
    icon: <FaWarehouse size={30} className="text-info" />,
    link: "reports_stock",
    params: { backTo: "reports" },
  },
  {
    title: "Stock Zero Report",
    description: "View a list of items that are out of stock.",
    icon: <FaExclamationTriangle size={30} className="text-danger" />,
    link: "reports_stock_zero",
    params: { backTo: "reports" },
  },
  {
    title: "Rounds",
    description: "View government penny rounding adjustments and totals.",
    icon: <FaCoins size={30} className="text-warning" />,
    link: "reports_rounds",
    params: { backTo: "reports" },
  },
];

const ReportsHome = () => {
  const dispatch = useDispatch();
  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">📊 Reports Dashboard</h2>
      <Row>
        {reports.map((report, index) => (
          <Col key={index} sm="12" md="6" lg="4" className="mb-4">
            <Link
              onClick={() => {
                if (report.params) {
                  dispatch(
                    openViewWithParams({
                      view: report.link,
                      params: report.params,
                    })
                  );
                } else {
                  dispatch(openView(report.link));
                }
              }}
              className="text-decoration-none"
            >
              <Card className="shadow-sm p-3 report-card border-0">
                <div className="d-flex align-items-center">
                  <div className="me-3">{report.icon}</div>
                  <div>
                    <h5 className="mb-1">{report.title}</h5>
                    <p className="text-muted mb-0">{report.description}</p>
                  </div>
                </div>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ReportsHome;
